module.exports = __webpack_public_path__ + "static/media/group-8@3x.f140f10b.png";